export default "__VITE_ASSET__CXC$6_Ux__"